export { MigriWidget as default } from "./MigriWidget";